(function () {
    "use strict";

    // @ngInject
    function CreateOpportunityControllerCtor($scope, $window, $injector, $modalInstance, $translate, $timeout, OpportunityTypesService, moment, UIUtils, AnalyticsService,
                                             Enums, NetworkManager, RepositoryService, ModelFactory, $location, modalParams, GeoLocationHelper, ServiceLazyLoaderService,
                                             PopupMessageService, $q, DeviceService, $, _) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CreateOpportunityController';
        this.$q = $q;
        this.$ = $;
        this._ = _;
        this.$window = $window;
        this.$modalInstance = $modalInstance;
        this.$timeout = $timeout;
        this.currTimeout = null;
        this.moment = moment;
        this.RepositoryService = RepositoryService;
        this.ModelFactory = ModelFactory;
        this.google = ServiceLazyLoaderService.get('google');
        this.$location = $location;
        this.UIUtils = UIUtils;
        this.DistTypes = Enums.OpportunityDistributionTypes;
        this.NetworkManager = NetworkManager;
        this.$translate = $translate;
        this.GeoLocationHelper = GeoLocationHelper;
        this.selectedVendorTypes = [];
        this.AnalyticsService = AnalyticsService;
        this.PopupMessageService = PopupMessageService;
        this.selectedItem = null;
        this.searchText = null;
        this.DeviceService = DeviceService;
        this.isMobile = this.DeviceService.checkIfMobileSize();
        this.TITLE_SETTINGS = {
            MAX_LENGTH: 140,
            MAX_NEGATIVE_CHARS: 60,
            CHANGE_STYLE_AFTER_CHARS: 125,
            MIN_CHARS_TO_SHOW_COUNTER: 80
        };

        this.MAX_SELECTED_VENDOR_TYPES = 5;

        this.generalFormErrorMessage = '';

        this.isFormValid = true;

        this.vendorTypeSelectedModel = undefined;

        this.vendorTypes = Enums.SupportedCreativeTypes.map(function (item) {
            return {key: item.key, name: $translate.instant(item.translationEntry)};
        });

        this.$modalInstance.onBeforeClose = this.onBeforeClosingCreateOpportunityModal.bind(this);
        this._initFields(modalParams);

        this.steps = {
            1: {
                ctaText: {default:"Next: Audience", mobile: "NEXT" },
                title : "Create Opportunity",
                errorMessage : this._step1ErrorMessage.bind(this),
                isValidAndSubmitted : true
            },
            2: {
                ctaText: {default:"POST OPPORTUNITY", mobile: "POST" },
                title : "Target Audience",
                errorMessage : this._step2ErrorMessage.bind(this),
                isValidAndSubmitted : true
            }
        };

        $scope.$on('$destroy', function () {
            if (this.referral) {
                this.referral.off('success', this._onSaveNetwrorkReferralSuccess);
            }

            if (this.currTimeout) {
                this.$timeout.cancel(this.currTimeout);
            }
            this.$window.removeEventListener('resize', this.onPageResize);
            window.onbeforeunload = null;
        }.bind(this));

        $scope.$watch('createOpportunityVm.shareIsoForm.$dirty', function(isDirtyNow, wasDirtyBefore) {
            //adding browser confirm message on before leaving the url
            window.onbeforeunload = function (e) {
                return (isDirtyNow || undefined);
            };
        });

        this.OPPORTUNITY_TYPES = OpportunityTypesService.list;
        $scope.$watch('createOpportunityVm.selectedOpportunityType', function (newSelectedOpportunityType, oldSelectedOpportunityType) {
            if (newSelectedOpportunityType !== oldSelectedOpportunityType) {
                if (newSelectedOpportunityType) {
                    this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.action,
                        {
                            unique: 'select_opp_type',
                            page: 'opp_select_type',
                            opp_type : newSelectedOpportunityType
                        });

                    this.opportunityTypeItemClickHandler(newSelectedOpportunityType);
                } else {
                    this.currSelectedOpportunityObject = '';
                }
            }
        }.bind(this));

        function setDirtyIfNeed(newTitle, oldTitle) {
                if (newTitle && newTitle !== oldTitle) {
                    this.shareIsoForm.$setDirty();
                }
        }

        $scope.$watch('createOpportunityVm.lookingFor', setDirtyIfNeed.bind(this));
        $scope.$watch('createOpportunityVm.description', setDirtyIfNeed.bind(this));

        function openOpportunityTypeDropDown() {
            angular.element('#opportunity-type').click();
        }

        this.onPageResize = this.onPageResize.bind(this);
        this.$window.addEventListener('resize', this.onPageResize);

        this.currTimeout = this.$timeout(function() {
            // save dialog width for the carousel animation of the multi step modal
            this.onPageResize();
            openOpportunityTypeDropDown();
        }.bind(this), 100);

        this._allowTabbingInCurrentStep(1);

        // Workaround to have the modal backdrop dismissing the modal.
        // Since the overlay click event is called also on button click!
        this.$timeout(function () {
            $('.create-opportunity-modal__overlay').click(function(e) {
                if (e.currentTarget === e.target) {
                    this.dismiss();
                }
            }.bind(this));
        }.bind(this), 1000);
    }

    Controllers.CreateOpportunityController = Class(Controllers.BaseController, {

        constructor: CreateOpportunityControllerCtor,

        onPageResize : function onPageResize () {
            this.isMobile = this.DeviceService.checkIfMobileSize();
            this.dialogWidth = this.$('.create-opportunity-modal .hb-modal-multi-step__step').outerWidth();
        },

        onBeforeClosingCreateOpportunityModal: function onBeforeClosingCreateOpportunityModal() {

            var deferred = this.$q.defer();
            if (this.shareIsoForm.$dirty) {
                this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.warning, 'Looks like your opportunity isn\'t finished.  The information you’ve entered will be lost if you leave. Would you like to abandon this opportunity?',
                    function user_confirm_leaving_opportunity_create_modal() {
                        deferred.resolve();
                    }.bind(this),
                    function() { deferred.reject('not allowed.');}
                );
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        },

        getVendorTypesString : function getVendorTypesString() {

            var vendorTypeString = '';

            if (!this.selectedVendorTypes || this.selectedVendorTypes.length === 0)  {
                return '';
            }

            var vendorTypesNames  = this._.map(this.selectedVendorTypes, function(vendorType){ return vendorType.name; });

            var lastType = vendorTypesNames.pop();
            if (vendorTypesNames.length >= 1) {
                vendorTypeString = vendorTypesNames.join(', ') + " & ";
            }

            return (vendorTypeString + lastType);
        },

        _initFields: function _initFields(modalParams) {
            if (modalParams) {
                if (modalParams.isFeedLocationGeocoded) {
                    this.userOriginalLocationFromProfile = modalParams.feedLocationLabel;
                    this.isoLocation = modalParams.feedLocationLabel;
                    this.isoCoordinates = modalParams.feedLocationCoordinates;
                    this.isIsoLocationGeocoded = true;
                } else {
                    this.isIsoLocationGeocoded = false;
                }
            }
            this.currentStep = 1;
            this.selectedOpportunityType = '';
            this.maxBudget = '';
            this.minBudget = '';
            this.lookingFor = '';
            this.description = '';

            this.isIsoLocationEverywhere = false;
            this.isIsoLocationIncomplete = true;

            this._initTitlePlaceholder();
        },

        _initTitlePlaceholder : function _initPlaceholder() {
            var now = new Date();
            var oneMonthFromNow = this.moment(now).add(1, 'M').format('MMM DD, YYYY');
            this.lookingForPlaceholder = this.$translate.instant('NETWORK.FEED._LOOKING_FOR_PLACEHOLDER_', {date: oneMonthFromNow});
        },

        close: function close(passedDataFromModal) {
            this.$modalInstance.close(passedDataFromModal);
        },

        dismiss: function dismiss() {
            this.$modalInstance.dismiss();
        },

        _isValidStep1: function _isValidStep1() {
            return (this._step1ErrorMessage() === '');
        },

        _isValidStep2: function _isValidStep2() {
            return (this._step2ErrorMessage() === '');
        },

        isVendorTypeInvalid : function isVendorTypeInvalid() {
           return ((this.selectedVendorTypes.length === 0) || (this.selectedVendorTypes.length > this.MAX_SELECTED_VENDOR_TYPES));
        },

        isLocationInvalid: function isLocationInvalid() {
            return (!this.isIsoLocationEverywhere && !this.isIsoLocationGeocoded);
        },

        handleClickIsoLocationClear: function handleClickIsoLocationClear() {
            this.isoLocation = null;
            this.isoCoordinates = [];
            this.isIsoLocationGeocoded = false;
            this.isIsoLocationIncomplete = true;
        },

        getTitleCounter: function() {
            var titleCounter = '';
            if (this.lookingFor && (this.lookingFor.length >= this.TITLE_SETTINGS.MIN_CHARS_TO_SHOW_COUNTER)) {
                titleCounter = this.TITLE_SETTINGS.MAX_LENGTH - this.lookingFor.length;
            }
            return titleCounter;
        },

        setShowAllLocationInfo: function setShowAllLocationInfo(show) {
            this.isShowPostToAllLocationsInfo = show;
        },

        updateIsoLocation: function updateIsoLocation(geoIsoCodeResult) {

            var activeIsoLocation = this.GeoLocationHelper.getGeoLocationData(geoIsoCodeResult);
            this.initMap({lng: activeIsoLocation.coordinates[0], lat: activeIsoLocation.coordinates[1]});

            this.isoLocation = activeIsoLocation.fullAddress;
            this.isoCoordinates = activeIsoLocation.coordinates;
            this.isIsoLocationGeocoded = true;
            this.isIsoLocationIncomplete = false;

            this.shareIsoForm.iso_location.$setValidity("notSelected", true);
        },

        initMap: function initMap(coordinates) {

            var self = this;
            this.google.then(function(googleSdk) {
                var map = new googleSdk.maps.Map(document.getElementById('create_opportunity_map'), {
                    zoom: 5,
                    center: coordinates,
                    disableDefaultUI: true
                });

                googleSdk.maps.event.addListener(map, "tilesloaded", function () {
                  [].slice.apply(document.querySelectorAll('#create_opportunity_map a')).forEach(function (item) {
                        item.setAttribute('tabindex', '-1');
                    });

                    self.$('#create_opportunity_map .gm-style > div:first-child').attr('tabindex', '-1');
                });
            });

        },

        saveReferral: function saveReferral() {
            try {

                var referralData = {
                    looking_for: this.lookingFor,
                    description: this.description,
                    vendor_types: this.selectedVendorTypes.map(function(item) { return item.key;}),
                    coordinates: this.isoCoordinates,
                    opportunity_type: this.selectedOpportunityType
                };

                if (this.maxBudget || this.minBudget) {
                    if (this.maxBudget && !this.minBudget) {
                        // little tweak to align same functionality sa the mobile-app.
                        referralData.min_budget = this.maxBudget;
                    } else {
                        referralData.min_budget = this.minBudget;
                        referralData.max_budget = this.maxBudget;
                    }
                }

                if (this.isIsoLocationEverywhere) {
                    referralData.dist_type = this.DistTypes.anywhere;
                    referralData.location = 'All Locations';
                } else if (this.isIsoLocationGeocoded) {
                    referralData.dist_type = this.DistTypes.pinLocation;
                    referralData.location = this.isoLocation;
                }

                this._onSaveNetwrorkReferralSuccess = this._onSaveNetwrorkReferralSuccess.bind(this, referralData);
                this.referral = this.NetworkManager.saveNetworkReferral(referralData);
                this.referral.on("success", this._onSaveNetwrorkReferralSuccess);



            } catch (e) {
                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.action,
                    {
                        unique: 'error_posting_opportunity',
                        page: 'opportunities_modal',
                        errorObject: e,
                        errorMessage: e.message
                    });


                this.steps[this.currentStep].isValidAndSubmitted = false;
                this.generalFormErrorMessage = "Oops... something went wrong. Please try again";
                this.isFormValid = false;
            }
        },

        _onSaveNetwrorkReferralSuccess: function _onSaveNetwrorkReferralSuccess(referralData) {
            var locationAnalytics = 'other';
            if (referralData.dist_type === this.DistTypes.anywhere) {
                locationAnalytics = 'everywhere';
            } else if (referralData.location === this.userOriginalLocationFromProfile) {
                locationAnalytics = 'profile';
            }

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.success,
                {
                    unique: 'opp_posted_successfully',
                    page: 'opps_more_details',
                    creatives_tagged: referralData.vendor_types.length,
                    description: this._.isEmpty(referralData.description),
                    location: locationAnalytics,
                    opp_type: referralData.opportunity_type
                });

            this._resetErrors();
            var dataToBeReturned = {
                referralId: this.referral._id,
                isoCoordinates: this.isoCoordinates,
                isIsoLocationEverywhere: this.isIsoLocationEverywhere,
                isoLocation: this.isoLocation,
                referral: this.referral,
                isIsoLocationGeocoded: this.isIsoLocationGeocoded
            };

            this.currentStep = 3;
            this.shareIsoForm.$setPristine();

            this.currTimeout = this.$timeout(function () {
                this.close({status: 'ok', data: dataToBeReturned});
            }.bind(this), 3000);

        },

        handleIsoLocationChanged: function handleIsoLocationChanged() {
            this.isIsoLocationGeocoded = false;
            this.isIsoLocationIncomplete = true;
        },

        handleIsoLocationBlurred: function handleIsoLocationBlurred() {
            if (!this.isIsoLocationGeocoded && this.isoCoordinates) {
                this.isoCoordinates = [];
                this.isIsoLocationIncomplete = true;
                // if city was edited but not chosen from drop down it is not valid
                // if (this.isoLocation.$dirty){
                //     this.isoLocation.$setValidity("notSelected", false);
                // }
            }
        },

        isTitleTooLong: function isTitleTooLong() {
            var titleCounter = this.getTitleCounter();
            return (titleCounter !== '' && titleCounter < 0);
        },

        isOppTypeInvalid: function isValidOppType() {
            return (this.selectedOpportunityType === '');
        },

        isTitleInvalid : function isTitleInvalid() {
            return (!this.lookingFor || (this.lookingFor.trim() === ''));
        },

        isBudgetInvalid : function isBudgetInvalid() {
            return (this.minBudget && this.maxBudget && (this.minBudget > this.maxBudget));
        },

        _addErrorCssClassToModal: function _addErrorCssClassToModal() {
            this.$('.create-opportunity-modal').addClass('network-feed-share__form__error-animation');
            this.currTimeout = this.$timeout(this._removeErrorCssClassFromModal, 2000);
        },

        _removeErrorCssClassFromModal: function _addErrorCssClassToModal() {
            this.$('.create-opportunity-modal').removeClass('network-feed-share__form__error-animation');
        },

        _resetErrors: function _resetErrors() {
            this._removeErrorCssClassFromModal();
            this.steps[1].isValidAndSubmitted = true;
            this.steps[2].isValidAndSubmitted = true;
            this.isFormValid = true;
            this.generalFormErrorMessage = '';
        },

        _step1ErrorMessage : function() {
            var errorMessage = '';
            if (this.isOppTypeInvalid()) {
                errorMessage = errorMessage.concat("<li>Please select an opportunity type</li>");
            }

            if (this.isTitleInvalid()) {
                errorMessage = errorMessage.concat("<li>Please add a title in order to post</li>");
            }

            if (this.isBudgetInvalid()) {
                errorMessage = errorMessage.concat("<li>Budget maximum should be higher than minimum</li>");
            }

            if (this.isTitleTooLong()) {
                errorMessage = errorMessage.concat("<li>Title should have a max of 140 chars</li>");
            }

            return errorMessage;
        },

        _step2ErrorMessage : function() {

            var errorMessage = '';
            if (this.isVendorTypeInvalid()) {
                if (this.vendorTypeSelectedModel !== undefined) {
                    errorMessage = errorMessage.concat("<li>Please pick one of the industry type from the list</li>");
                } else {
                    errorMessage = errorMessage.concat("<li>Please pick 1 to 5 creative types to notify</li>");
                }

            }

            if (this.isLocationInvalid()) {
                errorMessage = errorMessage.concat("<li>Select a location from the list</li>");
            }

            if (!this.isFormValid) {
                errorMessage = errorMessage.concat("<li>" + this.generalFormErrorMessage + "</li>");
            }

            return errorMessage;
        },

        _switchStep: function (stepNum) {
            this.$('.create-opportunity-modal__overlay').animate({ scrollTop: 0 }, {duration: 500, easing: 'linear'});
            this.currentStep = stepNum;
            this._allowTabbingInCurrentStep(stepNum);
            angular.element('.hb-modal__footer__button').blur();
        },

        _allowTabbingInCurrentStep: function (stepNum) {


            this.$timeout(function () {

                // disable all inputs
                this.$('.hb-modal-multi-step__step :input').each(function () {
                    this.$(this).prop("disabled", true);
                }.bind(this));

                // enable this step inputs
                this.$('.hb-modal-multi-step__step--' + stepNum + ' :input').each(function () {
                    this.$(this).prop("disabled", false);
                }.bind(this));


            }.bind(this), 0);
        },

        getSuggestedVendorTypes: function getSuggestedVendorTypes(textToAnalyze) {
            var self = this;
            var suggestedVendorTypes = [];

            var getAllPrefixesOfString = function getAllPrefixesOfString(string) {
                var allPrefixes = [];
                var MIN_WORD_LENGTH = 4;
                var blackListedWords = ['other', 'virtual', 'product', 'services', 'design', 'station'];
                var splittedString = string.split(/(?:\s(?:\/\s)?)/);
                self._.each(splittedString, function(splittedStringItem) {
                    if (self._.contains(blackListedWords, splittedStringItem)) {
                        return;
                    }

                    var min_length = Math.max(MIN_WORD_LENGTH, Math.ceil(splittedStringItem.length / 2));
                    if (splittedStringItem.length < min_length) {
                        return;
                    }

                    for (var i = min_length; i <= splittedStringItem.length; i++) {
                        allPrefixes.push(splittedStringItem.substring(0, i));
                    }
                });
                return allPrefixes;
            };

            var hasMatchingPrefix = function hasMatchingPrefix(sourcePrefixesObject, dictionaryItemPrefixesArray) {

                // for each string the user typed
                for (var key in sourcePrefixesObject) {
                    if (sourcePrefixesObject.hasOwnProperty(key)) {
                        // do an intersection with the prefixes of the current item in the dictionary.
                        var intersectedArray = self._.intersection(sourcePrefixesObject[key], dictionaryItemPrefixesArray);
                        if (intersectedArray.length > 0) {
                            return true;
                        }
                    }
                }
                return false;
            };

            var getSourcePrefixesObject = function getSourcePrefixesObject() {
                var textToAnalyzePrefixesObject = {};
                var textToAnalyzeArray = textToAnalyze.trim().toLowerCase().split(/[\s,\\.]+/);
                textToAnalyzeArray = self._.uniq(textToAnalyzeArray);
                self._.each(textToAnalyzeArray, function(textToAnalyzeArrayItem) {
                    textToAnalyzePrefixesObject[textToAnalyzeArrayItem] = getAllPrefixesOfString(textToAnalyzeArrayItem);
                });
                return textToAnalyzePrefixesObject;
            };

            var textToAnalyzePrefixesObject = getSourcePrefixesObject();

            this._.each(this.vendorTypes, function(vendorTypeItem) {
                var currVendorTypeName = vendorTypeItem.name.toLowerCase();
                var isStringExists = hasMatchingPrefix(textToAnalyzePrefixesObject, getAllPrefixesOfString(currVendorTypeName));
                if (isStringExists) {
                    if (!self._.contains(suggestedVendorTypes, vendorTypeItem) && suggestedVendorTypes.length < this.MAX_SELECTED_VENDOR_TYPES) {
                        suggestedVendorTypes.push(vendorTypeItem);
                    }
                }
            }.bind(this));
            return suggestedVendorTypes;
        },

        addSuggestedVendorTypes: function addSuggestedVendorTypes() {
           this.selectedVendorTypes = this.getSuggestedVendorTypes(this.lookingFor);
        },

        nextAction: function nextAction() {
            switch (this.currentStep) {
                case 1 :
                    this.steps[this.currentStep].isValidAndSubmitted = this._isValidStep1();
                    if (this.steps[this.currentStep].isValidAndSubmitted) {

                        this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.action,
                            {
                                unique: 'next_to_more_opp_details',
                                page: 'opps_looking_for'
                            });

                        if (this.isIsoLocationGeocoded && this.isoCoordinates) {
                            this.initMap({lng: this.isoCoordinates[0], lat: this.isoCoordinates[1]});
                        }

                        this.addSuggestedVendorTypes();
                        this.shrinkModal();
                        this._resetErrors();
                        this._switchStep(2);
                    } else {
                        this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.error,
                            {
                                unique: 'error_next_to_more_opp_details',
                                page: 'opps_looking_for'
                            });

                        this._addErrorCssClassToModal();
                    }
                    break;
                case 2:
                    this.steps[this.currentStep].isValidAndSubmitted = this._isValidStep2();
                    if (this.steps[this.currentStep].isValidAndSubmitted) {

                        this.shareIsoForm.$setSubmitted();
                        this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.action,
                            {
                                unique: 'opp_submit',
                                page: 'opps_more_details'
                            });
                        this.saveReferral();
                    } else {
                        this._addErrorCssClassToModal();
                    }
                    break;
                default:
                    break;
            }
        },

        inputAllowNumbersOnly: function inputAllowNumbersOnly(e) {
            var keyCode = (e.keyCode ? e.keyCode : e.which);
            if (keyCode > 31 && (keyCode < 48 || keyCode > 57)) {
                e.preventDefault();
            }
        },

        opportunityTypeItemClickHandler: function(opportunity_type_key) {
            this.currSelectedOpportunityObject = this.OPPORTUNITY_TYPES[opportunity_type_key];
            this.shareIsoForm.$setDirty();
        },

        getCtaText : function getCtaText() {
            var ctaText = "";
            if (this.steps[this.currentStep]) {
                if (this.isMobile) {
                    ctaText = this.steps[this.currentStep].ctaText.mobile;
                } else {
                    ctaText = this.steps[this.currentStep].ctaText.default;
                }
            }
            return ctaText;
        },

        previous: function previous() {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.action,
                {
                    unique: 'click_previous',
                    page: 'opportunities_modal',
                    from_page: this.currentStep
                });

            this.unshrinkModal();
            this._resetErrors();
            this._switchStep(this.currentStep - 1);
        },

        shrinkModal: function shrinkModal() {
            this.$('.hb-modal-multi-step__step--1').addClass('create-opportunity-modal__shrink');
        },

        unshrinkModal: function unshrinkModal() {
            this.$('.hb-modal-multi-step__step--1').removeClass('create-opportunity-modal__shrink');
        }


    });
}());
